import { Component, OnInit, NgZone } from '@angular/core';
import { UsuarioToken } from '../../../models/usuarioToken';
import { AuthService } from '../../admin/auth.service';

@Component({
  selector: 'head-bar',
  templateUrl: './head-bar.component.html'
})
export class HeadBarComponent implements OnInit {

  public usuario: UsuarioToken;

  constructor(private authService: AuthService, private ngZone: NgZone) { }

  ngOnInit() {
    this.usuario = this.authService.informacoesUsuario();
  }

  logOut() {
    this.authService.logOut();
    this.ngZone.runOutsideAngular(() => location.href = '');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/_admin-layout/head-bar/head-bar.component.ts